import { render } from "./UserPaymentRecordView.vue?vue&type=template&id=82bd4330&scoped=true"
import script from "./UserPaymentRecordView.vue?vue&type=script&lang=js"
export * from "./UserPaymentRecordView.vue?vue&type=script&lang=js"

import "./UserPaymentRecordView.vue?vue&type=style&index=0&id=82bd4330&scoped=true&lang=css"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82bd4330"]])

export default __exports__